<template>
    <div class="loader">

        <div :class="loadingContainerClass">
            <slot v-if="loaded">
            </slot>
        </div>

        <div :class="loadingIconContainerClass">
            <div v-if="false === loaded" :class="loadingIconClass">&nbsp;</div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Loader',
    props: {
        loaded: {
            default: false,
            type: Boolean,
        },
        fullScreen: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        loadingIconContainerClass() {
            return this.fullScreen ? 'w-full h-screen flex items-center justify-center' : 'w-full flex items-center justify-center';
        },

        loadingIconClass() {
            return this.loaded ? 'loader__loading-icon--loaded fa-spin' : 'loader__loading-icon fa-spin';
        },

        loadingContainerClass() {
            return this.loaded ? 'loader__container--loaded' : 'loader__container';
        },
    },
};
</script>
